<template>
  <div class="header">
    <div class="wp">
      <router-link to="/" tag="div" class="logo"
        ><img :src="imageUrl + logo" alt="AMIT"
      /></router-link>
      <span class="menuBtn"><b></b><b></b><b></b></span>

      <!-- <dl class="select">
        <dt>
          <p>{{ lang == "zh" ? "中文" : lang }}</p>
        </dt>
        <dd>
          <ul>
            <li @click="changeLangeHandle('zh')">
              <span
                ><img src="../assets/images/zh.gif" alt="中文" />
                <p>中文</p>
              </span>
            </li>

            <li @click="changeLangeHandle('en')">
              <span
                ><img src="../assets/images/en.gif" alt="en" />
                <p>en</p>
              </span>
            </li>
          </ul>
        </dd>
      </dl> -->
      <div class="search_box">
        <div class="attr-nav">
          <a class="search" rel="nofollow" href="#"><i></i></a>
        </div>
        <div class="top-search clearfix">
          <div class="wp">
            <h4>{{ $t("header.search.title") }}</h4>
            <div class="header_search clearfix">
              <input
                name="search_keyword"
                type="text"
                class="form-control"
                v-model="keyword"
                @keyup.enter.prevent="searchEnterFun($event)"
                :placeholder="$t('header.search.placeholder')"
              />
              <div class="search_btn btn_search1" @click="handleSo"></div>
            </div>
            <span class="input-group-addon close-search"></span>
          </div>
        </div>
      </div>
      <ul class="nav" v-if="navlist.length">
        <template v-for="(item, index) of navlist">
          <li v-if="item.show" :key="index">
            <template v-if="item.name !== isService">
              <div class="v1" @click="toUrl(item.url)">
                {{ item.name }}
              </div>
              <i class="dropIcon" v-if="item.sub"></i>
              <div class="sub" v-if="item.sub">
                <template v-for="(item, index) of item.sub">
                  <div
                    class="v2"
                    :key="index"
                    v-if="item.show"
                    @click="toUrl(item.url)"
                  >
                    {{ item.name }}
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div class="v1">{{ item.name }}</div>
              <i class="dropIcon" v-if="item.sub && item.show"></i>
              <div class="sub" v-if="item.sub">
                <template v-for="(item, index) of item.sub">
                  <div
                    class="v2"
                    :key="index"
                    v-if="item.show && item.url !== '/case'"
                    @click="toService(item.url, item.cid)"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    class="v2"
                    :key="index"
                    v-if="item.show && item.url == '/case'"
                    @click="toUrl(item.url)"
                  >
                    {{ item.name }}
                  </div>
                </template>
              </div>
            </template>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logo: '',
      lang: 'en',
      keyword: '',
      isService: 'Service',
      siteInfo: {
        zhId: '1437791619985682433',
        enId: '1428188362019659778'
      },
      navlist: [],
      subNav: {}
    }
  },
  /* computed: {
    langChange () {
      return (name, enname) => {
        switch (this.$i18n.locale) {
          case "zh": {
            if (name != null && name != undefined && name.length == 0) {
              return enname;
            }
            return name;
          }
          case "en": {
            if (enname != null && enname != undefined && enname.length == 0) {
              return name;
            }
            return enname;
          }
        }
      };
    },
  }, */
  created () {
    let that = this;
    /* if (that.$i18n.locale === 'zh') {
      that.isService = '服务';
      that.getInfo(that.siteInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.isService = 'Service';
      that.getInfo(that.siteInfo.enId);
    } */

    that.isService = 'Service';
    that.getInfo(that.siteInfo.enId);
  },
  watch: {
    '$route': 'getPath'
  },
  methods: {
    changeLangeHandle (lang) {
      let that = this
      /* that.lang = lang;
      that.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (that.lang === 'zh') {
        that.isService = '服务';
        that.getInfo(that.siteInfo.zhId);
      } else if (that.lang === 'en') {
        that.isService = 'Service';
        that.getInfo(that.siteInfo.enId);
      } */
      that.isService = 'Service';
      that.getInfo(that.siteInfo.enId);
    },
    toUrl (url) {
      if (url && this.$route.path !== url) {
        this.$router.push(url);
      }else{
        return false
      }

    },
    toService (name, id) {
      let that = this, serid = id;
      localStorage.setItem('serId', serid);
      that.$store.commit('changeServiceId', serid);
      if (that.$route.path == '/service') {
        return;
      } else {
        that.$router.push({ name: 'Service', params: { id: serid } })
      }
    },
    // 获取站点信息
    getInfo (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getInfo(data)
        .then((res) => {
          if (res.code == 200) {
            that.logo = res.result.siteLogo ? res.result.siteLogo.split(',')[0] : [];
            let dataConfigs = JSON.parse(res.result.dataConfigs);
            that.navlist = dataConfigs.nav.list;
            that.subNav = dataConfigs.subNav;
            that.$store.commit('changenavlist', that.navlist);
            let serid;
            that.navlist.map(item=>{
              if (item.name.toLowerCase()=='service') {

                for (let index = 0; index < item.sub.length; index++) {
                  if (item.sub[index].show) {
                    serid = item.sub[index].cid
                    break
                  }

                }
              }
            })

            localStorage.setItem('serId',serid)
            document.title = res.result.siteName;
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.result.siteKeyword);
            document.querySelector('meta[name="description"]').setAttribute('content', res.result.siteDescription);

            that.getPath();
          }
        })
    },
    // 切换语言时判断当前路径是否隐藏，若隐藏跳转至首页
    getPath () {
      let that = this;
      let path = that.$route.path
      for (let i = 0; i < that.navlist.length; i++) {
        for (let idx in that.navlist[i].sub) {
          if (that.navlist[i].sub[idx].url == path && that.navlist[i].sub[idx].show == 0) {
            that.$router.push('/');
            break;
          }
        }
      }


    },
    //点击回车，进行搜索
    searchEnterFun (e) {
      let keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.handleSo();
      }
    },
    // 搜索，跳转至结果页
    handleSo () {
      let that = this;
      if (that.keyword == '') {
        that.open();
        return false;
      }
      $('.top-search').stop().slideUp();
      // 通过commit 触发 mutation 并传参
      that.$store.commit('changeData', that.keyword);
      if (that.$route.path == '/res') {
        that.keyword = ''
        return;
      } else {
        that.$router.push({ name: 'Res', params: { keyword: that.keyword } })
        that.keyword = ''
      }
    },
    // 若搜索关键字为空时，给出提示
    open () {
      let that = this, txt = '';
      /* if (that.lang === 'zh') {
        txt = '请输入搜索内容'
      } else if (that.lang === 'en') {
        txt = 'Please enter the search content'
      } */
      txt = 'Please enter the search content'
      that.$message(
        {
          message: txt,
          type: 'warning'
        }
      );
    },
  }
}
</script>
<style>
</style>
